import { RootState } from './index';
import { defaultPost } from './postSlice';

export const selectPostById = (state: RootState, smmPackId: string | null) => smmPackId ? state.post.lastPosts[smmPackId] : defaultPost;
export const selectSettingsById = (state: RootState, smmPackId: string | null) => smmPackId ? state.post.lastPosts[smmPackId].settings : defaultPost.settings;
export const selectAllPosts = (state: RootState) => state.post.lastPosts;